/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { ModelUtils } from '../util/ModelUtils';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { Document } from '../../core/models/Document';
import { Oas30Document } from '../../openapi/v3/models/Oas30Document';
import { Oas30ResponseDefinition } from '../../openapi/v3/models/Oas30ResponseDefinition';
import { NewResponseDefinitionCommand } from './NewResponseDefinitionCommand';

/**
 * @author eric.wittmann@gmail.com
 * @extends NewResponseDefinitionCommand
 * @class
 */
export class NewResponseDefinitionCommand_30 extends NewResponseDefinitionCommand {
    public _nullComponents : boolean;

    public constructor(definitionName? : any, description? : any) {
        if(((typeof definitionName === 'string') || definitionName === null) && ((typeof description === 'string') || description === null)) {
            let __args = arguments;
            super();
            if(this._nullComponents===undefined) this._nullComponents = false;
            if(this._nullComponents===undefined) this._nullComponents = false;
            (() => {
                this._newDefinitionName = definitionName;
                this._newDefinitionDescription = description;
            })();
        } else if(definitionName === undefined && description === undefined) {
            let __args = arguments;
            super();
            if(this._nullComponents===undefined) this._nullComponents = false;
            if(this._nullComponents===undefined) this._nullComponents = false;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#execute(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[NewResponseDefinitionCommand] Executing.");
        let doc30 : Oas30Document = <Oas30Document>document;
        if(this.isNullOrUndefined(doc30.components)) {
            doc30.components = doc30.createComponents();
            this._nullComponents = true;
        }
        this._nullComponents = false;
        if(this.isNullOrUndefined(doc30.components.getResponseDefinition(this._newDefinitionName))) {
            let definition : Oas30ResponseDefinition = doc30.components.createResponseDefinition(this._newDefinitionName);
            if(ModelUtils.isDefined(this._newDefinitionDescription)) {
                definition.description = this._newDefinitionDescription;
            }
            doc30.components.addResponseDefinition(this._newDefinitionName, definition);
            this._defExisted = false;
        } else {
            this._defExisted = true;
        }
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#undo(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[NewResponseDefinitionCommand] Reverting.");
        let doc30 : Oas30Document = <Oas30Document>document;
        if(this._nullComponents) {
            doc30.components = null;
        }
        if(this._defExisted) {
            return;
        }
        doc30.components.removeResponseDefinition(this._newDefinitionName);
    }
}
NewResponseDefinitionCommand_30["__class"] = "io.apicurio.datamodels.cmd.commands.NewResponseDefinitionCommand_30";
NewResponseDefinitionCommand_30["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




